import { useState } from 'react';
import './LandingPage.css';
import AuthModal from './AuthModal';

export default function LandingPage({ onLogin }) {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState('signup');
  const [email, setEmail] = useState('');

  const openSignup = () => { setModalMode('signup'); setShowModal(true); };
  const openSignin = () => { setModalMode('signin'); setShowModal(true); };

  return (
    <div className="landing-page">
      {/* Background vehicle image with cinematic treatment */}
      <div className="landing-bg">
        <img src="/bg-vehicle.png" alt="" className="landing-bg-img" />
        <div className="landing-bg-tint" />
      </div>
      <div className="landing-overlay" />

      {/* Fixed outside nav so mix-blend-mode: screen blends against the actual bg */}
      <img src="/axion-logo.png" alt="Axion Mobility" className="landing-logo-img" />

      <nav className="landing-nav">
        <button className="landing-signin-btn" onClick={openSignin}>Sign In</button>
      </nav>

      <div className="landing-hero">
        <h1>Electric Fleet.<br />Zero Upfront Cost.</h1>
        <p className="landing-tagline">Subscribe. Scale. Sustain.</p>
        <p className="landing-sub">
          Ready to electrify your business?<br />
          Enter your email to get started.
        </p>
        <div className="landing-input-row">
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <button className="landing-cta-btn" onClick={openSignup}>
            Get Started &rsaquo;
          </button>
        </div>
      </div>

      {showModal && (
        <AuthModal
          mode={modalMode}
          initialEmail={email}
          onClose={() => setShowModal(false)}
          onSuccess={onLogin}
          onSwitchMode={m => setModalMode(m)}
        />
      )}
    </div>
  );
}
